export default __webpack_public_path__ + "static/media/Portfolio-logo.61e521bc.png";